<template>
  <el-dialog title="推荐意见" :visible.sync="dialogVisible" width="1200px" top="5vh" class="recommendation-edit-dialog"
    :close-on-click-modal="false" @close="handleClose">
    <div class="recommendation-edit-container" v-loading="loading">
      <div class="reTitle mt20">中华国际科技交流基金会</div>
      <div class="reTitle mt20">“双推双促工程”新动能科技成果</div>
      <div class="reTitle mt20">入围成果推荐意见书</div>
      <el-form ref="form" :model="formData" :rules="rules" label-width="180px" size="small">
        <!-- 高技术价值 -->
        <div class="mt30">
          <span>申报成果名称：{{name}}</span>
          <span class="ml30">申报单位：{{org_name}}</span>
        </div>
        <div class="formHeader">
          <div class="line"></div>
          <div class="formHeaderText">高技术价值</div>
        </div>

        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-form-item label="自主原创重大技术成果" prop="original">
              <el-select filterable clearable v-model="formData.original" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="前沿引领创新技术成果" prop="innovate">
              <el-select filterable clearable v-model="formData.innovate" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="产业关键核心技术成果" prop="core">
              <el-select filterable clearable v-model="formData.core" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="formHeader">
          <div class="line"></div>
          <div class="formHeaderText">高产业价值</div>
        </div>

        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-form-item label="助力传统产业转型升级" prop="tradition">
              <el-select filterable clearable v-model="formData.tradition" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="支撑战略新兴产业发展" prop="develop">
              <el-select filterable clearable v-model="formData.develop" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="发挥未来产业定位方向" prop="strategy">
              <el-select filterable clearable v-model="formData.strategy" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="formHeader">
          <div class="line"></div>
          <div class="formHeaderText">高经济价值</div>
        </div>

        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-form-item label="项目已实现营收规模大" prop="realize">
              <el-select filterable clearable v-model="formData.realize" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="项目对地区经济贡献大" prop="market">
              <el-select filterable clearable v-model="formData.market" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="项目可实现效益预期大" prop="profit">
              <el-select filterable clearable v-model="formData.profit" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="formHeader">
          <div class="line"></div>
          <div class="formHeaderText">高市场价值</div>
        </div>

        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-form-item label="成果目标市场规模巨大" prop="target_market">
              <el-select filterable clearable v-model="formData.target_market" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="成果推广应用场景多元" prop="promote">
              <el-select filterable clearable v-model="formData.promote" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="成果市场生命周期可见" prop="life_cycle">
              <el-select filterable clearable v-model="formData.life_cycle" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>




        <div class="formHeader">
          <div class="line"></div>
          <div class="formHeaderText">高资本价值</div>
        </div>

        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-form-item label="项目方向投资热度较高" prop="investment_heat">
              <el-select filterable clearable v-model="formData.investment_heat" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="项目团队运作能力较强" prop="team_operations">
              <el-select filterable clearable v-model="formData.team_operations" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="项目实施风险防控可信" prop="implementation_risk">
              <el-select filterable clearable v-model="formData.implementation_risk" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="formHeader">
          <div class="line"></div>
          <div class="formHeaderText">高转化价值</div>
        </div>

        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-form-item label="主体企业创新能力到位" prop="generality">
              <el-select filterable clearable v-model="formData.generality" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="成果转化资源要素到位" prop="resources">
              <el-select filterable clearable v-model="formData.resources" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="成果转化落地进程到位" prop="prepare">
              <el-select filterable clearable v-model="formData.prepare" placeholder="请选择">
                <el-option :label="value.name" :value="value.id" v-for="value in sourceOptions" :key="value.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="对该成果简要评语" prop="comment">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="formData.comment" />
        </el-form-item>
        <!-- <div ><span class="">*</span>对该成果简要评语</div>
        <el-input type="textarea"  :rows="4" placeholder="请输入内容" v-model="textarea" /> -->
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RecommendationEditDialog',
  data() {
    return {
      sourceOptions:[{id:'1',name:'符合'},{id:'2',name:'一般'}],
      dialogVisible: false,
      loading: false,
      submitLoading: false,
      formData: {
        original: '',
        innovate: '',
        core: '',
        tradition: '',
        develop: '',
        strategy: '',
        realize: '',
        market: '',
        profit: '',
        target_market: '',
        promote: '',
        life_cycle: '',
        investment_heat: '',
        team_operations: '',
        implementation_risk: '',
        generality: '',
        resources: '',
        prepare: '',
        comment: ''
      },
      xid:'',
      org_name:'',
      name:'',
      rules: {
        original: [
          { required: true, message: '请选择自主原创重大技术成果', trigger: 'change' }
        ],
        innovate: [
          { required: true, message: '请选择前沿引领创新技术成果', trigger: 'change' }
        ],
        core: [
          { required: true, message: '请选择产业关键核心技术成果', trigger: 'change' }
        ],
        tradition: [
          { required: true, message: '请选择助力传统产业转型升级', trigger: 'change' }
        ],
        develop: [
          { required: true, message: '请选择支撑战略新兴产业发展', trigger: 'change' }
        ],
        strategy: [
          { required: true, message: '请选择发挥未来产业定位方向', trigger: 'change' }
        ],
        realize: [
          { required: true, message: '请选择项目已实现营收规模', trigger: 'change' }
        ],
        market: [
          { required: true, message: '请选择项目对地区经济贡献', trigger: 'change' }
        ],
        profit: [
          { required: true, message: '请选择项目可实现效益预期', trigger: 'change' }
        ],
        target_market: [
          { required: true, message: '请选择成果目标市场规模', trigger: 'change' }
        ],
        promote: [
          { required: true, message: '请选择成果推广应用场景', trigger: 'change' }
        ],
        life_cycle: [
          { required: true, message: '请选择成果市场生命周期', trigger: 'change' }
        ],
        investment_heat: [
          { required: true, message: '请选择项目方向投资热度', trigger: 'change' }
        ],
        team_operations: [
          { required: true, message: '请选择项目团队运作能力', trigger: 'change' }
        ],
        implementation_risk: [
          { required: true, message: '请选择项目实施风险防控', trigger: 'change' }
        ],
        generality: [
          { required: true, message: '请选择主体企业创新能力', trigger: 'change' }
        ],
        resources: [
          { required: true, message: '请选择成果转化资源要素', trigger: 'change' }
        ],
        prepare: [
          { required: true, message: '请选择成果转化落地进程', trigger: 'change' }
        ],
        comment: [
          { required: true, message: '请输入成果简要评语', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      this.loading = true
      this.org_name =data.org_name
      this.name =data.name
      this.xid = data.xid
      this.getDetail(data.xid)
      console.log("1111111111",data)
      this.loading = false
    },
    getDetail(xid){
      this.$API.getRecommendationDetail({project_xid:xid}).then(res=>{
        if(res.data){
          this.formData = res.data
        }
      })
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
      this.resetFormData()
    },

    resetFormData() {
      this.formData = {
        original: '',
        innovate: '',
        core: '',
        tradition: '',
        develop: '',
        strategy: '',
        realize: '',
        market: '',
        profit: '',
        target_market: '',
        promote: '',
        life_cycle: '',
        investment_heat: '',
        team_operations: '',
        implementation_risk: '',
        generality: '',
        resources: '',
        prepare: '',
        comment: ''
      }
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          // 调用保存接口
          console.log("gggggggg",this.formData)
          this.formData.project_xid = this.xid
          if(this.formData.xid){
            delete this.formData.xid
          }
          this.$API.addOpinion(this.formData).then(res => {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.$emit('success', this.formData)
          }).catch(err => {
            console.error('保存失败:', err)
            this.$message.error('保存失败')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.recommendation-edit-dialog {
  ::v-deep .el-dialog {
    max-height: 90vh;
    overflow-y: auto;
  }

  .reTitle {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }

  .formHeader {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .line {
      width: 4px;
      height: 18px;
      background: #409EFF;
      margin-right: 10px;
    }

    .formHeaderText {
      font-size: 16px;
      color: #303133;
    }
  }
}

.ml30 {
  margin-left: 30px;
}

.mt30 {
  margin-bottom: 20px;
}

.mt20 {
  margin-bottom: 10px;
}
.dialog-footer{
  display: flex;
  justify-content:center;
}
</style>
